import { render, staticRenderFns } from "./semLastPage.vue?vue&type=template&id=0f7b2037&scoped=true&"
import script from "./semLastPage.vue?vue&type=script&lang=js&"
export * from "./semLastPage.vue?vue&type=script&lang=js&"
import style0 from "./semLastPage.vue?vue&type=style&index=0&id=0f7b2037&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7b2037",
  null
  
)

export default component.exports